export enum CompanyStatus {
    Active = "active",
    Suspend = "suspend",
    NotVerify = "not_verified",
    Expired = "expired"
}

export enum sortList {
    ASC = "ASC",
    DESC = 'DESC',
}

export enum sortBy {
    CreatedAt = "created_at",
    UpdatedAt = "updated_at",
    Name = 'name',
    approved_date = 'approved_date',
    company_name = 'company_name',
    end_date = "end_date",
    suspend_at = 'suspend_at',
    email_verified_at = 'email_verified_at'
}


export class ListingModel {
    search: string = '';
    sort: sortList = sortList.DESC;
    page: number = 0;
    perPage: number = 10;
    sortBy: sortBy = sortBy.CreatedAt
    is_link_refer_employee: any;
}

export class companyListModel extends ListingModel {
    status: CompanyStatus | '' = CompanyStatus.Active;
    city_id!: string;
    override sortBy: sortBy = sortBy.email_verified_at;
}

export interface CompanyObj {
    id: string;
    name_ar: string;
    name_en: string;
    balance: number;
    city_name: string;
    created_at: string;
    updated_at: string;
    logo: string;
    end_date: string;
    email_verified_at: string;
    suspend_at: string;
    package: {
        name_en: string;
        name_ar: string;
    };
    num_employees: number;

}



export class walletTrancactionsModel extends ListingModel {
    company_ids_array: string[] = [];
    type: "withdraw" | "recharge" | '' = ''
}


export interface TransactionRecordInterface {
    profileImg: any;
    nameEn: string;
    nameAR: any;
    createdDate: any;
    id: string
    type: string
    created_at: string
    amount: number
    arrow: string
    company: {
        name_en: string
        name_ar: string
        logo: string
    }
    payment: {
        name: string
        payment_last_4_digits: string
        logo: string
    }
}

export enum RequestStatus {
    New = "new",
    Approved = "approved",
    Rejected = "rejected",
}

export class withdrawalRequestsModel extends ListingModel {
    end_date: string = '';
    start_date: string = '';
    status: RequestStatus = RequestStatus.New;
}



export interface withdrawalRequestsInterface {
    id: string
    created_at: string
    updated_at: string
    approved_date: string
    amount: number
    arrow: string
    company: {
        name_en: string
        name_ar: string
        logo: string
    }
}




export class RegisterationRequestsModel extends ListingModel {
    city_id!: string;
    status: RequestStatus = RequestStatus.New;
}



export interface RegisterationRequestsInterface {
    id: string
    name_en: string
    name_ar: string
    logo: string
    created_at: string
    updated_at: string
    approved_date: string
    transaction_number: string
    reason_to_reject: any
    transaction_file: any
    transaction_file_object: any
    package: any
    city_name: string

}







export class RewardedEmployeesModel extends ListingModel {
    end_date: string = '';
    start_date: string = '';
    override sortBy: any = 'num_points ';
}



export interface RewardedEmployeesInterface {
    id: string
    created_at: string
    num_points: number
    num_employees: number
    company: {
        name_en: string
        name_ar: string
        logo: string
    }

}












